// add type to ensure all values are unique regardless of object nesting
type UniqueStringObject<T> = {
    [K in keyof T]: T[K] extends string ? T[K] : UniqueStringObject<T[K]>;
} & { __unique?: never };

const posthogEventIds = {
    Wallet: {
        connected: "wallet-connected",
        disconnected: "wallet-disconnected",
        transactionInitiated: "wallet-transaction-initiated",
    },
    WhaleRetentionDialog: {
        opened: "whale-retention-dialog-opened",
        closed: "whale-retention-dialog-closed",
        TelegramButton: {
            clicked: "whale-retention-dialog-telegram-clicked",
        },
    },
    WithdrawLockFormDialog: {
        opened: "withdraw-lock-form-dialog-opened",
        closed: "withdraw-lock-form-dialog-closed",
        SubmitButton: {
            clicked: "withdraw-lock-form-dialog-submit-clicked",
        },
    },
    WithdrawLockTransactionDialog: {
        opened: "withdraw-lock-transaction-dialog-opened",
        closed: "withdraw-lock-transaction-dialog-closed",
        StartWithdrawalButton: {
            clicked: "withdraw-lock-transaction-dialog-start-withdrawal-clicked",
        },
        WithdrawalTransaction: {
            success: "withdraw-lock-transaction-dialog-transaction-success",
            failure: "withdraw-lock-transaction-dialog-transaction-failure",
        },
    },
    ExitLockFeedbackDialog: {
        opened: "exit-lock-feedback-dialog-opened",
        closed: "exit-lock-feedback-dialog-closed",
        ContinueButton: {
            clickedToSkip: "exit-lock-feedback-dialog-continue-clicked",
            clickedAfterAddingFeedback: "exit-lock-feedback-dialog-continue-clicked-after-feedback",
        },
    },
    ExitLockWhaleDialog: {
        opened: "exit-lock-whale-dialog-opened",
        closed: "exit-lock-whale-dialog-closed",
        ContinueButton: {
            clickedToSkip: "exit-lock-whale-dialog-continue-clicked",
            clickedAfterClickingContact: "exit-lock-whale-dialog-continue-clicked-after-contact",
        },
        ContactButton: {
            clicked: "exit-lock-whale-dialog-contact-clicked",
        },
    },
};

export const PostHogEvent: UniqueStringObject<typeof posthogEventIds> = posthogEventIds;

export const PostHogAction = {
    [PostHogEvent.Wallet.connected]: "connect wallet",
    [PostHogEvent.Wallet.disconnected]: "disconnect wallet",
    [PostHogEvent.Wallet.transactionInitiated]: "initiate transaction",
    [PostHogEvent.WhaleRetentionDialog.opened]: "open dialog",
    [PostHogEvent.WhaleRetentionDialog.closed]: "close dialog",
    [PostHogEvent.WhaleRetentionDialog.TelegramButton.clicked]: "click button",
    [PostHogEvent.WithdrawLockFormDialog.opened]: "open dialog",
    [PostHogEvent.WithdrawLockFormDialog.closed]: "close dialog",
    [PostHogEvent.WithdrawLockFormDialog.SubmitButton.clicked]: "click button",
    [PostHogEvent.ExitLockFeedbackDialog.opened]: "open dialog",
    [PostHogEvent.ExitLockWhaleDialog.opened]: "open dialog",
    [PostHogEvent.ExitLockWhaleDialog.ContactButton.clicked]: "click button",
    [PostHogEvent.ExitLockFeedbackDialog.ContinueButton.clickedToSkip]: "click button",
    [PostHogEvent.ExitLockFeedbackDialog.ContinueButton.clickedAfterAddingFeedback]: "click button",
    [PostHogEvent.ExitLockWhaleDialog.ContinueButton.clickedToSkip]: "click button",
    [PostHogEvent.ExitLockWhaleDialog.ContinueButton.clickedAfterClickingContact]: "click button",
};
